import React from 'react';
import { Section, Container } from 'components/shared';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import styled from 'styled-components';
import breakpoints from 'utils/breakpoints';
import tw from 'twin.macro';
import useNewColorSchemaOptions from 'utils/hooks/useNewColorSchemaOptions';
import {
  CommunityProductOverviewSummary,
  CommunityProductOverviewHomeDetails,
} from 'components/components/molecules';
import cx from 'classnames';

const StyledSection = styled(Section)`
  ${tw`focus:outline-none`}

  ${({ showNewSchemaColor, newSchemaColorHexaCode }) =>
    showNewSchemaColor && `background-color: ${newSchemaColorHexaCode};`}
  }
`;
const ContainerCommunityProductOverviewHomeDetails = styled.div`
  @media ${breakpoints.md} {
    border-left: 1px solid #e0e4ea;  
`;

const getRanges = (ranges) => {
  if (ranges && ranges.length > 4) {
    const r = ranges.split(' - ');
    if (r[0] === '0' && r[1] === '0') return '';
    if (r[0] === r[1]) return r[0];
  }
  return typeof ranges !== 'undefined' ? ranges : '';
};

const CommunityProductOverview = ({ fields }) => {
  const result = getFieldValue(fields, 'result') || {};
  const productOverviewView = result.productOverviewView || {};
  const homeDetails = result.homeDetails || {};

  const {
    newSchemaColorHexaCode,
    newSchemaTextColorHexaCode,
    showNewSchemaColor,
  } = useNewColorSchemaOptions();
  const whiteBackground =
    productOverviewView.backColor &&
    productOverviewView.backColor === 'bg-white';

  const stats = homeDetails
    ? [
        {
          value: getRanges(homeDetails.bedroomRanges),
        },
        {
          value: getRanges(homeDetails.fullBathRanges),
        },
        {
          value: getRanges(homeDetails.halfBathRanges),
        },
        {
          value: getRanges(homeDetails.sqFtRanges),
        },
        {
          value: getRanges(homeDetails.storyRanges),
        },
        {
          value: getRanges(homeDetails.garageRanges),
        },
      ].filter((s) => s.value !== '')
    : [];
  const showHomeDetails = stats.length > 0;

  return (
    <StyledSection
      id={'ProductOverview'}
      className={showNewSchemaColor ? '' : productOverviewView.backColor}
      whiteBackground={showNewSchemaColor ? false : whiteBackground}
      tabIndex='-1'
      showNewSchemaColor={showNewSchemaColor}
      newSchemaColorHexaCode={newSchemaColorHexaCode}
      newSchemaTextColorHexaCode={newSchemaTextColorHexaCode}
    >
      <Container className='flex flex-col md:flex-row items-center'>
        <div
          className={cx('w-full ', {
            'md:w-2/3': showHomeDetails,
          })}
        >
          <CommunityProductOverviewSummary
            productOverviewView={productOverviewView}
          />
        </div>
        {showHomeDetails && (
          <ContainerCommunityProductOverviewHomeDetails className='w-full md:w-1/3'>
            <CommunityProductOverviewHomeDetails homeDetails={homeDetails} />
          </ContainerCommunityProductOverviewHomeDetails>
        )}
      </Container>
    </StyledSection>
  );
};

export default CommunityProductOverview;
